<template>
  <van-notice-bar
    wrapable
    :scrollable="false"
    color="#484848"
    background="#F1F1F1"
    left-icon="records"
  >
    <p class="text3Indentation">
      会算账，是早知心基于个人工作生活情况，以及医疗服务在中医侧的惠民政策，推出的个人“小账本”。可以大体
      帮助个人了解中医的特殊优惠政策范围，帮助客户节约支付费用，减少负担。<strong
        >（注：由于相关政策存在信息时效问题，请您在就医过程中和医疗机构进行核实）</strong
      >
    </p>
  </van-notice-bar>
  <van-cell-group title="" inset>
    <van-field
      left-icon="wap-home"
      v-model="userInfo.hospitalName"
      label="体检机构"
      readonl
    >
    </van-field>
    <van-field
      left-icon="user-o"
      v-model="userInfo.realName"
      label="真实姓名"
      readonly
    />
    <van-field
      left-icon="phone-o"
      v-model="userInfo.phone"
      label="预留手机号"
      readonly
    />
  </van-cell-group>
  <br />
  <van-form @submit="onSubmit">
    <van-space direction="vertical" size="2rem" fill>
      <van-row>
        <van-col offset="0.5" span="24">
          <van-cell-group inset>
            <van-notice-bar
              :theme-vars="themeVars"
              wrapable
              :scrollable="false"
            >
              （1）、你的医保是否是职工医疗保险？
            </van-notice-bar>
            <van-cell>
              <van-radio-group
                v-model="question.userFinanceVo.sanXiHealthCare"
                direction="horizontal"
              >
                <van-radio name="1" icon-size="24px">是</van-radio>
                <van-radio name="0" icon-size="24px">否</van-radio>
              </van-radio-group>
            </van-cell>
            <van-notice-bar
              :theme-vars="themeVars"
              wrapable
              :scrollable="false"
            >
              （2）、您是否是离退休人员？
            </van-notice-bar>
            <van-cell>
              <van-radio-group
                v-model="question.userFinanceVo.retire"
                direction="horizontal"
              >
                <van-radio name="1" icon-size="24px">已退休</van-radio>
                <van-radio name="0" icon-size="24px">在岗</van-radio>
              </van-radio-group>
            </van-cell>
            <van-notice-bar
              :theme-vars="themeVars"
              wrapable
              :scrollable="false"
            >
              （3）、您什么时间方便就诊？
            </van-notice-bar>
            <van-cell>
              <van-radio-group v-model="question.userFinanceVo.visitDoctor">
                <van-radio name="1" icon-size="24px"
                  >工作日（周一-周五）</van-radio
                >
                <br />
                <van-radio name="2" icon-size="24px"
                  >周末（周六、周日）</van-radio
                >
                <br />
                <van-radio name="0" icon-size="24px">任何时间</van-radio>
              </van-radio-group>
            </van-cell>
            <van-notice-bar
              :theme-vars="themeVars"
              wrapable
              :scrollable="false"
            >
              （4）、您希望费用支付方式？
            </van-notice-bar>
            <van-cell>
              <van-radio-group
                v-model="question.userFinanceVo.personalAdvances"
              >
                <van-radio name="0" icon-size="24px"
                  >不想个人垫付，优先统筹结算</van-radio
                >
                <br />
                <van-radio name="1" icon-size="24px"
                  >可以个人先垫付，只要可以报销</van-radio
                >
              </van-radio-group>
            </van-cell>
            <van-notice-bar
              :theme-vars="themeVars"
              wrapable
              :scrollable="false"
            >
              （5）、您是否除了国家社保外，还有有企业补充医疗保险？
            </van-notice-bar>
            <van-cell>
              <van-radio-group
                v-model="question.userFinanceVo.jiaMeiEmployees"
                direction="horizontal"
              >
                <van-radio name="1" icon-size="24px">是</van-radio>
                <van-radio name="0" icon-size="24px">否</van-radio>
              </van-radio-group>
            </van-cell>
          </van-cell-group>
        </van-col>
      </van-row>
    </van-space>
    <div style="margin: 16px">
      <van-button
        color="linear-gradient(to right, #f67f34, #d55809)"
        round
        block
        native-type="submit"
        @click="getQueSave"
        >预估省钱方案</van-button
      >
    </div>
 
    <van-notice-bar :show="showPayPlan" wrapable :scrollable="false" left-icon="volume-o">
        <p class="text2DIndentation">注：支付方案只能大体反映支付配比部分，由于选择的药品和技术的差异、以及各类管理制度的变化，所有方案都会存在较大的误差，您在就医过程中随时注意支出情况。</p>  
      </van-notice-bar>
    <p v-if="showPayPlan">基于您的当前情况，可以使用的支付方案：</p>
    <p v-if="showPayPlan" class="text2DIndentation">
      多种支付方案需要根据个人健康情况进行选择，由医生给出最终适用方式。个人可以将自己情况向医生讲明。
      </p>
    <div v-if="showBaoXiao" class="about" id="level1"></div>
    <div v-if="showZhYi" class="about" id="level2"></div>
    <div v-if="showRiHome" class="about" id="level"></div>
  </van-form>
  <van-overlay :show="showOverlay" @click="showOverlay = false">
        <div class="wrapper" @click.stop>
            <div class="block">
                <van-cell-group inset>
                    <van-notice-bar wrapable :scrollable="false" text="异常提醒" left-icon="info-o" />
                    <p class="textIndentation">
                        <van-notice-bar wrapable :scrollable="false" color="#1989fa" background="#ffffff">{{ bingingNotice
                        }}</van-notice-bar>
                    </p>
                    <van-button v-if="goToUserInfo" type="warning" block plain hairline to="bindingHosp">
                        开始绑定
                    </van-button>
                    <van-button v-if="goToAbout" type="warning" block plain hairline to="about">
                        返回项目介绍
                    </van-button>
                </van-cell-group>
            </div>
        </div>
    </van-overlay>
</template>
<script>
import { ref, toRefs, reactive, onMounted } from "vue";
import { getUserInfo } from "../../api/userinfo";
import * as echarts from "echarts";
import { postUserFinanceInfo } from "../../api/userFinance";
import { getCheckBinding } from '../../api/permission';

export default {
  setup() {
    const active = ref(1);
    const bingingNotice = ref('');
    const showOverlay = ref(false);
    const showPayPlan = ref(false);
    const showRiHome =ref(true);
    const showBaoXiao =ref(true);
    const showZhYi =ref(true);
    const goToUserInfo = ref(false);
    const goToAbout = ref(false);
    const state = reactive({
      userInfo: {
        hospitalName: "",
        area: "",
        realName: "",
        phone: "",
        age: "",
        gender: "",
      },
    });
    const question = reactive({
      userFinanceVo: {
        jiaMeiEmployees: "",
        sanXiHealthCare: "",
        retire: "",
        visitDoctor: "",
        personalAdvances: "",
        allFee: "",
        riHomePay: "",
        riHomeZhPay: "",
        comPersonPay: "",
        comYibaoPay: "",
        comPay: "",
        personPay: "",
        yiBaoPay: "",
        zhPay: "",
      },
    });
    const themeVars = reactive({
      fontSizeMd: 32,
    });
    const getQueSave = () => {
      console.log(question.userFinanceVo);
      postUserFinanceInfo(question.userFinanceVo).then((res) => {
        showPayPlan.value=true;
        question.userFinanceVo = res.data.data;
        console.log(question.userFinanceVo.comPay);
        if(question.userFinanceVo.comPay != null){
          levelComInit();
        }else{
          showBaoXiao.value=false;
        }
        console.log(question.userFinanceVo.zhPay);
        if(question.userFinanceVo.zhPay != null){
          levelZhInit();
        }else{
          showZhYi.value=false;
        }
        console.log(question.userFinanceVo.riHomeZhPay);
        if(question.userFinanceVo.riHomeZhPay != null){
          levelInit();
        }else{
          showRiHome.value=false;
        }
      });
    };
    onMounted(() => {
      getCheckBinding().then((res1) => {
                console.log(res1.data.code);
                const binding = res1.data.code;
                if (binding == 60002) {
                    showOverlay.value = true;
                    bingingNotice.value = "【绑定进度未完成】：我们会在1～3个工作日内完成";
                    goToAbout.value = true;
                } else if (binding == 60000) {
                    showOverlay.value = true;
                    bingingNotice.value = "【绑定异常】：早知心，目前仅开放体检机构侧邀约指定客户绑定。您可以向体检机构获取【邀请码】";
                    goToUserInfo.value = true;
                } else if (binding == 40000) {
                    showOverlay.value = true;
                    bingingNotice.value = "【登陆异常】：请您在微信端打开";
                    goToAbout.value = true;
                } else {
                  getUserInfo().then((res1) => {
                        state.userInfo = res1.data.data;
                        console.log(res1.data.data);
                    });
                }
            })
    });
    function levelInit() {
      var myChart = echarts.init(document.getElementById("level"));
      console.log(question.userFinanceVo.riHomePay);
      myChart.setOption({
        title: {
          text: "日间病房方案",
          subtext: "适用部分高风险、时间自由安排人群",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },

        series: [
          {
            name: "以3000元支付额测算",
            type: "pie",
            radius: "50%",
            data: [
              { value: question.userFinanceVo.riHomePay, name: "日间病房个人支付" },
              { value: question.userFinanceVo.riHomeZhPay, name: "日间病房医保统筹" },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      });
    }
    function levelComInit() {
      var myChart1 = echarts.init(document.getElementById("level1"));
      console.log(question.userFinanceVo.comPay);
      myChart1.setOption({
        title: {
          text: "医保门诊方案",
          subtext: "适用病症不需要住院，只能走门诊支付的患者",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },

        series: [
          {
            name: "以3000元支付额测算",
            type: "pie",
            radius: "50%",
            data: [
              { value: question.userFinanceVo.comPersonPay, name: "个人支付" },
              { value: question.userFinanceVo.comYibaoPay, name: "医保统筹支付" },
              { value: question.userFinanceVo.comPay, name: "企业补充保险支付" },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      });
    }
    function levelZhInit() {
      var myChart2 = echarts.init(document.getElementById("level2"));
      console.log(question.userFinanceVo.zhPay);
      myChart2.setOption({
        title: {
          text: "中医适宜技术",
          subtext: "适用部分无企业二次报销，不是高风险人群",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },

        series: [
          {
            name: "以3000元支付额测算",
            type: "pie",
            radius: "50%",
            data: [
              { value: question.userFinanceVo.personPay, name: "个人支付" },
              { value: question.userFinanceVo.yiBaoPay, name: "医保统筹" },
              { value: question.userFinanceVo.zhPay, name: "中医适宜技术预计" },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      });
    }
    return {
      active,
      showOverlay,
      showPayPlan,
      showRiHome,
      showBaoXiao,
      showZhYi,
      bingingNotice,
      goToUserInfo,
      goToAbout,
      themeVars,
      question,
      getQueSave,
      ...toRefs(state),
    };
  },
};
</script>
<style lang="less" scoped>
/* 去除单元格cell下边框 */
.van-cell:after {
  border-bottom: none !important;
  border-bottom-style: none !important;
}

/* 单元格标题title */
.van-cell .van-cell__title {
  color: #7186e1;
}

/* 标题下方label */
.van-cell .van-cell__label {
  color: #000;
  font-weight: 500;
}

.textIndentation {
  font-size: 12px;
  text-align: left;
}
.text2DIndentation {
  font-size: 14px;
  text-align: left;
  padding-right: 1em;
  padding-left: 1em;
}
#level {
  height: 600px;
  width: 100%;
}
#level1 {
  height: 600px;
  width: 100%;
}
#level2 {
  height: 600px;
  width: 100%;
}
</style>
